// src/pages/Stocks/Stocks.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Stocks.css';

const Stocks = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 'ng-stocks',
      label: 'Core NG Assets',
      description: 'Buy & invest in verified stable NG ventures',
      path: '/stocks/category/ng-stocks',
      color: '#15A759',
      icon: '📈'
    },
    {
      id: 'private-equity',
      label: 'Private Equity',
      description: 'Buy & invest in NG companies before they are listed',
      path: '/stocks/category/private-equity',
      color: '#E8E8E8',
      icon: '📋'
    },
    {
      id: 'pre-ipo',
      label: 'SCALE-UP ASSETS',
      description: 'high growth NG businesses',
      path: '/stocks/category/pre-ipo',
      color: '#F5E942',
      icon: '🚀'
    },
    {
      id: 'fpo',
      label: 'GROWTH ROUNDS ASSETS',
      description: 'Buy later stage expansion businesses',
      path: '/stocks/category/fpo',
      color: '#FF0000',
      icon: '📊'
    },
    {
      id: 'invest',
      label: 'Invest',
      description: 'Build a portfolio of NG businesses',
      path: '/investment/stocks',
      color: '#15A759',
      icon: '🎯'
    },
    {
      id: 'plan',
      label: 'INCOME PLAN',
      description: 'Automatically invest funds into selected assets',
      path: '/plan',
      color: '#E8E8E8',
      icon: '📅'
    }
  ];

  const handleCategoryClick = (category) => {
    navigate(category.path);
  };

  return (
    <div className="stocks-container">
      <div className="stocks-header">
        <h1>Assets</h1>
        <p>explore available asset</p>
      </div>

      <div className="categories-grid">
        {categories.map(category => (
          <button
            key={category.id}
            className="category-button"
            onClick={() => handleCategoryClick(category)}
            style={{ 
              backgroundColor: category.color
            }}
          >
            <div className="button-content">
              <div className="button-icon">{category.icon}</div>
              <span 
                className="button-label" 
                style={{
                  color: category.color === '#E8E8E8' || category.color === '#F5E942' ? '#666' : '#fff'
                }}
              >
                {category.label}
              </span>
              <span 
                className="button-description"
                style={{
                  color: category.color === '#E8E8E8' || category.color === '#F5E942' ? '#666' : '#fff',
                  fontSize: '0.8rem',
                  opacity: 0.9,
                  maxWidth: '90%',
                  lineHeight: '1.2'
                }}
              >
                {category.description}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Stocks;